import ServiceRequest from '@/components/community_settings/ServiceRequests';
import store from '@/store';

export default {
    key: 'sreq',
    title: 'service requests',
    component: ServiceRequest,
    permissionChecker: () => store.getters['sreq/hasPermission']('CSV'),
};
